import { render } from "./CreateInvoicePage.vue?vue&type=template&id=527ab512&ts=true"
import script from "./CreateInvoicePage.vue?vue&type=script&lang=ts"
export * from "./CreateInvoicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__